import { Component, AfterViewInit, ElementRef, Inject, NgModule, ViewChild, HostListener, Input, Output, EventEmitter, AfterViewChecked } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { AnnouncementService } from 'src/app/shared/services/announcementservices/announcement.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import Swal from 'sweetalert2';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
declare const Swiper: any;

@Component({
  selector: 'app-announcement-view',
  templateUrl: './announcement-view.component.html',
  styleUrl: './announcement-view.component.css',
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule]
})
export class AnnouncementViewComponent implements AfterViewChecked, AfterViewInit {
  public showSpinner = false;
  @Input() announcements: any;

  @Output() deleteAnnouncementEvent = new EventEmitter<number>();
  filterStatus = 'all';
  idSendToModal: any;
  @Input() activeFilter = 'all';
  @Input() viewType: 'list' | 'grid' = 'list';
  @Output() filterChange = new EventEmitter<string>();
  user: any;

  user_role: any;
  adminCheck: boolean;
  categoryFilter: any;
  public selectedFilter = 'all';
  private swipers: any[] = [];
  private alreadyInitialized = false;
  selectedAnnouncement: any = null;
  activeTab = 'all';
  selectedTab = 'all';
  reactionTypes: string[] = ['wow', 'heart', 'like'];
  constructor(private router: Router,
    public _announcementService: AnnouncementService,
  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    const roles = JSON.parse(this.user?.user_role?.user_roles)
    this.user_role = roles?.role_type
    if (this.user_role == "Admin" || this.user_role == "Admin_AND_Team_Lead") {
      this.adminCheck = true;
      this.activeFilter = 'all';
    } else {
      this.adminCheck = false;
      this.categoryFilter = 'all';
    }

    const roleType = roles?.role_type;

    this.adminCheck = roleType === 'Admin' || roleType === 'Admin_AND_Team_Lead';

    this.selectedFilter = 'all';
  }
  ngAfterViewInit() {
    this.initSwipers();
  }

  ngAfterViewChecked() {
    if (!this.alreadyInitialized) {
      this.initSwipers();
      this.alreadyInitialized = true;
    }
  }
  onSomeSelectChange(event: Event) {
    const value = (event.target as HTMLSelectElement).value;
    this.filterChange.emit(value);
  }
  private initSwipers() {
    // destroy old ones
    this.swipers.forEach(swiper => swiper.destroy(true, true));
    this.swipers = [];

    if (!this.announcements?.all) return;

    setTimeout(() => {
      this.announcements.all.forEach((announcement: any) => {
        if (document.querySelector(`#swiper-${announcement.id}`)) {
          const swiper = new Swiper(`#swiper-${announcement.id}`, {
            slidesPerView: 1,
            loop: false,
            navigation: {
              nextEl: `#next-${announcement.id}`,
              prevEl: `#prev-${announcement.id}`
            },
            pagination: {
              el: `#pagination-${announcement.id}`,
              clickable: true
            }
          });
          this.swipers.push(swiper);
        }
      });
    }, 0);
  }


  selectFilter(filter: string) {
    this.selectedFilter = filter;
    setTimeout(() => this.initSwipers(), 100); // Re-init after DOM updates
  }






  get mainLabels(): string[] {
    return Object.keys(this.announcements || {});
  }
  setFilter(status: string) {
    this.filterStatus = status;
  }
  getFilteredAnnouncements() {
    if (!this.announcements || !this.announcements.all) return [];

    let filtered = [...this.announcements.all];

    const roleType = (() => {
      const rolesObj = this.user?.user_role?.user_roles
        ? JSON.parse(this.user.user_role.user_roles)
        : null;
      return rolesObj?.role_type;
    })();

    if (!this.adminCheck) {
      filtered = filtered.filter(a => a.status === 'active' || a.status === 'expired');
      if (this.selectedFilter !== 'all') {
        filtered = filtered.filter(a => a.category === this.selectedFilter);
      }
    } else {
      // Admin: filter by status only
      if (this.selectedFilter !== 'all') {
        filtered = filtered.filter(a => a.status === this.selectedFilter);
      }
    }

    return filtered;
  }



  // Example status helpers
  isExpired(announcement: any) {
    return new Date(announcement.expiry_date) < new Date();
  }

  isActive(announcement: any) {
    const now = new Date();
    return new Date(announcement.start_date) <= now && new Date(announcement.expiry_date) >= now;
  }

  isScheduled(announcement: any) {
    return new Date(announcement.start_date) > new Date();
  }

  isImage(file: string): boolean {
    return /\.(jpg|jpeg|png|gif)$/i.test(file);
  }

  isVideo(file: string): boolean {
    return /\.(mp4|mov|avi|mkv)$/i.test(file);
  }

  editAnnouncement(id: number) {
    this.router.navigate(['/add-announcement', id]);
  }

  idSendToModaldelete(id: number) {
    this.idSendToModal = id;
  }

  deleteAnnouncement(id: any) {
    this.showSpinner = true;
    const announcementId = id;
    if (announcementId) {
      this._announcementService.deleteAnnouncements(announcementId).then((value) => {
        this.showSpinner = false;

        if (value?.message == 'Announcement deleted successfully') {
          Swal.fire({
            iconHtml: '<img src="../../assets/images/success-modal.svg" alt="image">',
            title: 'Announcement Deleted Successfully',
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            // ✅ Refresh announcements after delete
            window.location.reload();
          });
        } else {
          Swal.fire({
            iconHtml: '<img src="../../assets/images/error-modal.svg" alt="image">',
            title: value?.message || 'Something went wrong',
            showConfirmButton: false,
            timer: 1500,
          });
        }

      }).catch((err) => {
        Swal.fire({
          iconHtml: '<img src="../../assets/images/error-modal.svg" alt="image">',
          title: 'Failed to delete announcement',
          showConfirmButton: false,
          timer: 1500,
        });
        console.error('Delete error:', err);
      });
    }
  }




  saveReaction(announcementId: number, reaction: string) {
    this.showSpinner = true;

    this._announcementService.addReaction(announcementId, reaction).then((value) => {
      window.location.reload();


    });

  }
  reactionImages: Record<string, string> = {
    like: '../../../assets/theme1/like.png',
    love: '../../../assets/theme1/love.png',
    dislike: '../../../assets/theme1/dislike.png',
    wow: '../../../assets/theme1/wow.png',
    laught: '../../../assets/theme1/laught.svg',
    angry: '../../../assets/theme1/angry.svg',
    upset: '../../../assets/theme1/upset.svg'
  };

  getReactions(counts: any) {
    if (!counts) return [];
    return Object.keys(counts).map(key => ({
      type: key,
      count: counts[key]
    }));
  }

  getReactionImage(type: string): string {
    return this.reactionImages[type] || '../../../assets/theme1/default.png';
  }
  // getTotalReactionCount(reactionCounts: { [key: string]: number }): number {
  //   if (!reactionCounts) return 0;
  //   return Object.values(reactionCounts).reduce((total, count) => total + count, 0);
  // }
  // hasReactions(reactionCounts: { [key: string]: number }): boolean {
  //   if (!reactionCounts) return false;
  //   return Object.values(reactionCounts).some(count => count > 0);
  // }


  // Static user data
  reactionUsers = [
    { name: 'Shafaq Jawad', role: 'HR Manager', reactionType: 'wow', avatar: 'https://kodex.workinsight.net/kodex-managment-system/public/img/17326531006746302c125c1', timestamp: '2023-08-21T00:08:00' },
    { name: 'Ali Khan', role: 'Developer', reactionType: 'love', avatar: 'https://randomuser.me/api/portraits/men/1.jpg', timestamp: '2023-08-21T00:10:00' },
    { name: 'Sara Ahmed', role: 'Designer', reactionType: 'like', avatar: 'https://randomuser.me/api/portraits/women/2.jpg', timestamp: '2023-08-21T00:12:00' },
    { name: 'John Doe', role: 'Manager', reactionType: 'wow', avatar: 'https://randomuser.me/api/portraits/men/3.jpg', timestamp: '2023-08-21T00:15:00' },
  ];



  // getReactionCount(type: string): number {
  //   if (type === 'all') return this.reactionUsers.length;
  //   return this.reactionUsers.filter(u => u.reactionType === type).length;
  // }
  openReactions(announcement: any) {
    this.selectedAnnouncement = announcement;
    this.selectedTab = 'all';
  }

  selectTab(type: string) {
    this.selectedTab = type;
  }

  // ✅ Use reactionCounts for tab counts
  getReactionCount(type: string): number {
    if (!this.selectedAnnouncement) return 0;
    if (type === 'all') {
      return Object.values(this.selectedAnnouncement.reactionCounts || {}).reduce(
        (total: number, val: any) => total + (val as number),
        0
      );
    }
    return this.selectedAnnouncement.reactionCounts?.[type] || 0;
  }

  // ✅ Use reactions list for filtering users
  filteredUsers() {
    if (!this.selectedAnnouncement?.reactions) return [];
    if (this.selectedTab === 'all') return this.selectedAnnouncement.reactions;

    return this.selectedAnnouncement.reactions.filter(
      (r: any) => r.reaction === this.selectedTab
    );
  }
  getAvailableReactionTypes(): string[] {
    if (!this.selectedAnnouncement?.reactionCounts) return [];
    // return only the keys that have count > 0
    return Object.keys(this.selectedAnnouncement.reactionCounts)
      .filter(type => this.selectedAnnouncement.reactionCounts[type] > 0);
  }
}
